import { Type } from 'class-transformer';
import { AlertResultDto } from './alert-result-dto';

export class CommunityAlertResultDto {
    communityID: number;
    allowAdd: boolean;
    @Type(() => AlertResultDto)
    alerts: Array<AlertResultDto>;
}
